export default __webpack_public_path__ + "static/media/mail_icon.13b2c188.svg";